export class Table {
	constructor(table, chart) {
		let _refresh = null;

		this.header = 0;
		this.firstCol = 0;
		this.byCols = true;

		const ta = table instanceof HTMLTableElement ? table : document.getElementById(table);

		this.table = ta;

		function enableColResize() {
			if (table) {
				var row = tb.getElementsByTagName("tr")[0];
				if (row) {
					cols = row.getElementsByTagName("td");
					if (!cols || cols.length == 0) {
						cols = row.getElementsByTagName("th");
					}

					if (cols) {
						for (var i = 0; i < cols.length; i++) {
							var a = document.createElement("div");
							a.className = "arrow-down";
							cols[i].appendChild(a);
						}
					}
				}
			}
		}

		function getStyle(x, styleProp) {
			if (x.currentStyle) {
				return x.currentStyle[styleProp];
			} else if (window.getComputedStyle) {
				return document.defaultView.getComputedStyle(x, null).getPropertyValue(styleProp);
			} else {
				return "";
			}
		}

		this.changeCell = function (cell) {
			if (!(cell instanceof HTMLTableCellElement)) {
				cell = this;
			}

			var s = cellText(cell),
				l = Math.max(s.length, 5);

			cell.onclick = null;

			var i = document.createElement("input");
			i.type = "text";
			i.style.width = cell.clientWidth + "px";

			i.onchange = changeValue;
			i.onkeydown = keyDown;
			i.onblur = changeValue;
			i.value = cell.innerHTML;

			i.className = "inline-editor";

			cell.innerHTML = "";
			cell.appendChild(i);

			cell.firstChild.focus();
		};

		const _table = this;

		function keyDown(e) {
			var key,
				text = this;
			if (window.event) {
				key = window.event.keyCode;
			} else if (e) {
				key = e.which;
			} else {
				return true;
			}

			var c = text.parentNode,
				r = c.parentNode,
				tbl = r.parentNode;

			if (key == 27) {
				changeValue(text);
			} else if (key == 13) {
				changeValue(text);
			}
			if (key == 9) {
				if (e && e.shiftKey) {
					if (c.cellIndex > _table.firstCol) {
						changeValue(text);
						_table.changeCell(tbl.rows[r.rowIndex].cells[c.cellIndex - 1]);
					} else if (r.rowIndex > 1) {
						changeValue(text);
						_table.changeCell(tbl.rows[r.rowIndex - 1].cells[r.cells.length - 1]);
					}
				} else {
					if (c.cellIndex < r.cells.length - 1) {
						changeValue(text);
						_table.changeCell(tbl.rows[r.rowIndex].cells[c.cellIndex + 1]);
					} else if (r.rowIndex < tbl.rows.length - 1) {
						changeValue(text);
						_table.changeCell(tbl.rows[r.rowIndex + 1].cells[1]);
					}
				}
				return false;
			} else if (key == 40) {
				if (r.rowIndex < tbl.rows.length - 1) {
					changeValue(text);
					_table.changeCell(tbl.rows[r.rowIndex + 1].cells[c.cellIndex]);
				}
			} else if (key == 38) {
				if (r.rowIndex > _table.header) {
					changeValue(text);
					_table.changeCell(tbl.rows[r.rowIndex - 1].cells[c.cellIndex]);
				}
			}

			return true;
		}

		function changeValue(text) {
			if (this instanceof HTMLInputElement) {
				text = this;
			}

			if (text.onchange) {
				text.onchange = null;

				var cell = text.parentNode;

				if (cell) {
					cell.innerHTML = text.value;
					cell.onclick = _table.changeCell;

					if (_refresh) {
						_refresh(cell);
					}
				}
			}
		}

		this.enableRowHighlight = function (color, panel) {
			if (typeof panel == "string") {
				panel = document.getElementById(panel);
			}

			if (ta) {
				for (var t = 0; t < ta.rows.length; t++) {
					ta.rows[t].onmouseover = function () {
						this.style.backgroundColor = color;

						if (panel) {
							panel.style.visibility = "visible";
						}
					};

					ta.rows[t].onmouseout = function () {
						this.style.backgroundColor = "#FFFFFF";

						if (panel) {
							panel.style.visibility = "hidden";
						}
					};
				}
			}
		};

		function refreshCell(cell) {
			var byCols = _table.byCols,
				ser,
				row,
				index,
				s = cell.innerHTML;

			if (byCols) {
				row = cell.parentNode.rowIndex;
				index = cell.cellIndex;
			} else {
				row = cell.cellIndex;
				index = cell.parentNode.rowIndex;
			}

			if (row == 1) {
				if (index == 1) {
					if (s != chart.footer.text) {
						chart.footer.text = s;
						chart.draw();
					}
				} else {
					ser = chart.series.items[index - 2];
					if (s != ser.title) {
						ser.title = s;
						chart.draw();
					}
				}
			} else {
				row -= 2;

				if (index == 1) {
					ser = chart.series.items[0];
					if (s != ser.data.labels[row]) {
						chart.series.each(function (s1) {
							s1.data.labels[row] = s;
						});

						chart.draw();
					}
				} else {
					ser = chart.series.items[index - 2];
					var n = parseFloat(s);

					if (n != ser.data.values[row]) {
						ser.data.values[row] = n;
						chart.draw();
					}
				}
			}
		}

		this.enableEditing = function (enable, refresh) {
			_refresh = refresh || refreshCell;

			if (ta) {
				for (var r = 0, row; (row = ta.rows[r]); r++) {
					if (row) {
						for (var c = 0, col; (col = row.cells[c]); c++) {
							if (col) {
								col.onclick = enable ? this.changeCell : null;
							}
						}
					}
				}
			}
		};

		function dohoverCell(cell, active) {
			if (active) {
				cell.style.backgroundColor = "gold";
				cell.style.color = "white";
			} else {
				cell.style.backgroundColor = "";
				cell.style.color = "";
			}
		}

		this.pointToCell = function (series, index) {
			var s = series.chart.series.items.indexOf(series) + 2;

			if (_table.byCols) {
				return ta.rows[index + 2].cells[s];
			} else {
				return ta.rows[s].cells[index + 2];
			}
		};

		this.hoverCell = function (series, index) {
			if (series.over != -1) {
				dohoverCell(_table.pointToCell(series, series.over), false);
			}

			if (index != -1) {
				dohoverCell(_table.pointToCell(series, index), true);
			}
		};

		function orderToIndex(i) {
			var n = -1;

			for (var t = 0; t < chart.series.count(); t++) {
				if (chart.series.items[t].visible) {
					n++;
					if (n == i) {
						return t;
					}
				}
			}

			return -1;
		}

		this.legendHover = function (old, index) {
			var tbl = ta,
				bycols = _table.byCols,
				pos = 1,
				c = chart;

			if (c.legend.showValues()) {
				var s = c.series.firstVisible();
				pos = 2 + c.series.items.indexOf(s);
				bycols = !bycols;
			}

			if (bycols) {
				if (old != -1) {
					dohoverCell(ta.rows[pos].cells[orderToIndex(old) + 2], false);
				}
				if (index != -1) {
					dohoverCell(ta.rows[pos].cells[orderToIndex(index) + 2], true);
				}
			} else {
				if (old != -1) {
					dohoverCell(ta.rows[old + 2].cells[pos], false);
				}
				if (index != -1) {
					dohoverCell(ta.rows[index + 2].cells[pos], true);
				}
			}
		};
	}
}
